import { FormEvent } from 'react';
import { Button, FormControl, Glyphicon, OverlayTrigger, Popover } from 'react-bootstrap';
import { Icon } from 'react-icons-kit'
import { questionCircleO } from 'react-icons-kit/fa/questionCircleO';

interface IProps {
    activityTypeId: number,
    startDate: string,
    endDate: string,
    donorAlias: string,
    onFieldChange: (field: string, value: any) => void,
    onExportCSV: () => void
}

const Filter = (props: IProps) => {
    const handleFieldChange = (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;
        props.onFieldChange(name, value);
    };

    const renderSearchHelp = () => {
        return (
            <OverlayTrigger overlay={<Popover>The recipient XM/Activity Log is filtered by date and may not contain all activities. To broaden your search, use the search donor feature to search by donor alias.</Popover>}>
                <sup><Icon size={16} icon={questionCircleO} /></sup>
            </OverlayTrigger>
        )
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', paddingLeft: 5 }}>
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                <div className='text-right' style={{ marginRight: 5, fontSize: 12 }}><strong>Activity Type:</strong></div>
                <div>
                    <FormControl
                        componentClass='select'
                        name='activityType'
                        value={props.activityTypeId}
                        onChange={handleFieldChange}
                        bsSize='sm'
                        style={{ width: '100%' }}
                    >
                        <option value={0}>- All -</option>
                        <option value={1}>Donor Pre-Select Decision</option>
                        <option value={2}>Cross Match Activity</option>
                        <option value={3}>Swap Activity</option>
                        <option value={4}>Request for Donor Review</option>
                    </FormControl>
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                <div style={{ marginRight: 5, fontSize: 12 }}><strong>Start Date:&nbsp;</strong></div>
                <div>
                    <FormControl
                        type='date'
                        name='startDate'
                        bsSize='sm'
                        value={props.startDate}
                        onChange={handleFieldChange}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                <div style={{ marginRight: 5, fontSize: 12 }}><strong>End Date:</strong></div>
                <div>
                    <FormControl
                        type='date'
                        name='endDate'
                        bsSize='sm'
                        value={props.endDate}
                        onChange={handleFieldChange}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                <div style={{ marginRight: 5, fontSize: 12 }}><strong>Donor Alias:{renderSearchHelp()}</strong></div>
                <div>
                    <FormControl
                        name='donorAlias'
                        bsSize='sm'
                        value={props.donorAlias}
                        onChange={handleFieldChange}
                    />
                </div>
            </div>
            <div>
                <Button onClick={props.onExportCSV} bsSize='sm' style={{ margin: 5 }}>
                    Export CSV
                </Button>
            </div>
        </div>
    );
}

export default Filter;